import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentId", "parentPlaylistId", "type"];
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboardField from '../CopyToClipboardField';
function getContentShareLink(_ref) {
  var contentId = _ref.contentId,
    parentPlaylistId = _ref.parentPlaylistId,
    type = _ref.type;
  var base = window.location.origin;
  if (type === 'playlist') {
    return "".concat(base, "/playlists/").concat(contentId);
  }
  if (parentPlaylistId) {
    return "".concat(base, "/playlists/").concat(parentPlaylistId, "?asset=").concat(contentId);
  }
  return "".concat(base, "/assets/").concat(contentId);
}
function ShareableLinkField(_ref2) {
  var contentId = _ref2.contentId,
    parentPlaylistId = _ref2.parentPlaylistId,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'asset' : _ref2$type,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var link = getContentShareLink({
    contentId: contentId,
    parentPlaylistId: parentPlaylistId,
    type: type
  });
  return /*#__PURE__*/React.createElement(CopyToClipboardField, _extends({
    value: link,
    label: t('form_shareable_link'),
    description: t('hint_content_shareable_link'),
    maxFieldWidth: 400
  }, otherProps));
}
export default ShareableLinkField;